const bubbles = [
  { size: 26, left: 4, delay: -7, duration: 19, drift: 38, opacity: .48 },
  { size: 74, left: 10, delay: -15, duration: 28, drift: -46, opacity: .30 },
  { size: 42, left: 17, delay: -3, duration: 23, drift: 64, opacity: .38 },
  { size: 118, left: 24, delay: -21, duration: 34, drift: -32, opacity: .22 },
  { size: 34, left: 31, delay: -11, duration: 21, drift: 48, opacity: .44 },
  { size: 62, left: 38, delay: -26, duration: 30, drift: -68, opacity: .29 },
  { size: 20, left: 44, delay: -5, duration: 17, drift: 30, opacity: .52 },
  { size: 92, left: 50, delay: -18, duration: 32, drift: 52, opacity: .25 },
  { size: 48, left: 57, delay: -9, duration: 24, drift: -42, opacity: .36 },
  { size: 138, left: 64, delay: -30, duration: 38, drift: 38, opacity: .18 },
  { size: 28, left: 70, delay: -13, duration: 20, drift: -50, opacity: .48 },
  { size: 68, left: 76, delay: -24, duration: 29, drift: 62, opacity: .30 },
  { size: 38, left: 83, delay: -2, duration: 22, drift: -34, opacity: .42 },
  { size: 104, left: 89, delay: -19, duration: 35, drift: -58, opacity: .21 },
  { size: 22, left: 95, delay: -10, duration: 18, drift: 24, opacity: .50 },
  { size: 54, left: 13, delay: -32, duration: 33, drift: 74, opacity: .27 },
  { size: 32, left: 61, delay: -16, duration: 25, drift: -62, opacity: .40 },
  { size: 82, left: 86, delay: -35, duration: 37, drift: 46, opacity: .23 },
];

export default function BubbleBackground() {
  return (
    <div className="bubble-field" aria-hidden="true">
      {bubbles.map((bubble, index) => (
        <span
          className="soap-bubble"
          key={index}
          style={{
            "--bubble-size": `${bubble.size}px`,
            "--bubble-left": `${bubble.left}%`,
            "--bubble-delay": `${bubble.delay}s`,
            "--bubble-duration": `${bubble.duration}s`,
            "--bubble-drift": `${bubble.drift}px`,
            "--bubble-opacity": bubble.opacity,
            "--shimmer-delay": `${bubble.delay * 0.37}s`,
          }}
        />
      ))}
    </div>
  );
}
